var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "tabcard",
          align: "left",
          inlineLabel: true,
          tabItems: _vm.tabItems,
        },
        on: { tabClick: _vm.tabClick },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    searchParam: _vm.searchParam,
                    tabParam: _vm.tabParam,
                    proceedingsTypeCd: tab.proceedingsTypeCd,
                  },
                  on: {
                    "update:searchParam": function ($event) {
                      _vm.searchParam = $event
                    },
                    "update:search-param": function ($event) {
                      _vm.searchParam = $event
                    },
                    "update:tabParam": function ($event) {
                      _vm.tabParam = $event
                    },
                    "update:tab-param": function ($event) {
                      _vm.tabParam = $event
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }